<template>
  <div>
    <Header class="yh-header" active="/" />
    <div style="height: 70px"></div>
    <el-container>
      <el-main>
        <div class="header">
          <div class="background">
            <img :src="util.getImageUrl(user.avatarUrl, '1100x205')" />
          </div>
          <div class="top">
            <img :src="util.getImageUrl(user.avatarUrl, '120x120')" />
          </div>
          <div class="name">你好！{{user.nickName || user.name}}</div>
          <div class="active-value">活跃值：{{my.activeValue.value}}</div>
          <div class="modify">
            <span @click="onShowModifyNickName">
              <img src="@/assets/修改昵称.png" />
              修改昵称
            </span>
            <el-divider direction="vertical"></el-divider>
            <span @click="onShowModifyAvatarUrl">
              <img src="@/assets/修改头像.png" />
              修改头像
            </span>
            <el-divider direction="vertical"></el-divider>
            <span @click="onShowModifyPassword">
              <img src="@/assets/修改密码.png" />
              修改密码
            </span>
          </div>
        </div>
        <div class="body">
          <el-tabs class="tabs" v-model="activeTab" stretch>
            <el-tab-pane name="active-value">
              <span slot="label">
                活跃值
                <span class="number">{{my.activeValue.value}}</span>
              </span>
              <MyActiveValue :my="my" />
            </el-tab-pane>
            <el-tab-pane label="收藏" name="collect">
              <span slot="label">
                收藏
                <span class="number">{{parseInt(my.collect)}}</span>
              </span>
              <MyCollect />
            </el-tab-pane>
            <el-tab-pane label="足迹" name="footprint">
              <span slot="label">
                足迹
                <span class="number">{{parseInt(my.footprint)}}</span>
              </span>
              <div class="footprint"></div>
              <MyFootprint />
            </el-tab-pane>
            <el-tab-pane label="在线时长" name="online-time">
              <span slot="label">
                在线时长(分钟)
                <span class="number">{{parseInt(my.onlineTime / 1000 / 60)}}</span>
              </span>
              <MyOnlineTime :my="my" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-main>
      <el-dialog
        title="修改昵称"
        :visible.sync="modifyNickNameDialogVisible"
        @submit.native.prevent
        width="25%"
      >
        <el-form :model="form">
          <el-form-item>
            <el-input v-model="form.nickName" placeholder="请输入您新的用户名" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="modifyNickNameDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="onModifyNickNameSubmit">保 存</el-button>
        </div>
      </el-dialog>
      <el-dialog title="修改头像" :visible.sync="modifyAvatarUrlDialogVisible" width="25%">
        <div style="text-align: center;">
          <img :src="util.getImageUrl(user.avatarUrl, '120x120')" class="avatar" />
          <el-upload
            action="http://foodsafety.yonghui.cn/api/resource/uploadFile"
            name="files"
            :on-success="onUploadSuccess"
            :show-file-list="false"
          >
            <el-button type="primary">
              <i class="el-icon-upload"></i>
              重新上传
            </el-button>
          </el-upload>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="modifyAvatarUrlDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="onModifyAvatarUrlSubmit">保 存</el-button>
        </div>
      </el-dialog>
      <el-dialog title="修改密码" :visible.sync="modifyPasswordDialogVisible" width="25%">
        <el-form :model="form">
          <el-form-item label="当前密码">
            <el-input
              type="password"
              v-model="form.oldPassword"
              placeholder="请输入当前密码"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码">
            <el-input
              type="password"
              v-model="form.newPassword"
              placeholder="请输入新密码"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认新密码">
            <el-input
              type="password"
              v-model="form.rePassword"
              placeholder="请输入新密码"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="modifyPasswordDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="onModifyPasswordSubmit">保 存</el-button>
        </div>
      </el-dialog>
    </el-container>
  </div>
</template>

<script>
import Header from "@/components/Header";

import MyActiveValue from "@/components/MyActiveValue";
import MyCollect from "@/components/MyCollect";
import MyFootprint from "@/components/MyFootprint";
import MyOnlineTime from "@/components/MyOnlineTime";

export default {
  name: "My",
  components: {
    Header,

    MyActiveValue,
    MyCollect,
    MyFootprint,
    MyOnlineTime
  },
  data() {
    return {
      modifyNickNameDialogVisible: false,
      modifyAvatarUrlDialogVisible: false,
      modifyPasswordDialogVisible: false,
      form: {
        nickName: "",
        avatarUrl: "",
        password: ""
      },
      activeTab: "active-value",
      more: false
    };
  },
  computed: {
    user() {
      return this.$store.state.sys.sysUser.me;
    },
    my() {
      return this.$store.state.sys.sysUser.my;
    }
  },
  created() {
    this.refresh();

    if (this.$route.query.modifyNickNameDialogVisible) {
      this.modifyNickNameDialogVisible = true;
    }
    if (this.$route.query.modifyAvatarUrlDialogVisible) {
      this.modifyAvatarUrlDialogVisible = true;
    }
    if (this.$route.query.modifyPasswordDialogVisible) {
      this.modifyPasswordDialogVisible = true;
    }

    this.ajax.doPost({
      packageName: "user",
      className: "userAnalysis",
      methodName: "create",
      params: {
        userId: this.$store.state.sys.sysUser.me.id,
        moduleName: "个人中心",
        moduleResourceId: this.$route.params.id,
        path: this.$route.path
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    if (to.query.modifyNickNameDialogVisible) {
      this.modifyNickNameDialogVisible = true;
    }
    if (to.query.modifyAvatarUrlDialogVisible) {
      this.modifyAvatarUrlDialogVisible = true;
    }
    if (to.query.modifyPasswordDialogVisible) {
      this.modifyPasswordDialogVisible = true;
    }

    next();
  },
  methods: {
    refresh() {
      this.$store.dispatch("me", {
        packageName: "sys",
        className: "sysUser",
        methodName: "me",
        params: {}
      });

      this.$store.dispatch("my", {
        packageName: "sys",
        className: "sysUser",
        methodName: "my",
        params: {}
      });
    },
    onShowModifyNickName() {
      this.modifyNickNameDialogVisible = true;
    },
    async onModifyNickNameSubmit() {
      await this.$store.dispatch("me", {
        packageName: "sys",
        className: "sysUser",
        methodName: "update",
        params: {
          id: this.user.id,
          nickName: this.form.nickName
        }
      });

      this.refresh();

      this.$message.success("修改昵称成功！");

      this.modifyNickNameDialogVisible = false;
    },
    onShowModifyAvatarUrl() {
      this.modifyAvatarUrlDialogVisible = true;
    },
    async onUploadSuccess(e) {
      await this.$store.dispatch("movePic", {
        packageName: "common",
        className: "resource",
        methodName: "movePic",
        params: {
          url: e.data.url
        }
      });

      this.form.avatarUrl = this.$store.state.common.resource.movePic;

      this.$message.success("上传成功！");
    },
    async onModifyAvatarUrlSubmit() {
      await this.$store.dispatch("me", {
        packageName: "sys",
        className: "sysUser",
        methodName: "update",
        params: {
          id: this.user.id,
          avatarUrl: this.form.avatarUrl
        }
      });

      this.refresh();

      this.$message.success("修改头像成功！");

      this.modifyAvatarUrlDialogVisible = false;
    },
    onShowModifyPassword() {
      this.modifyPasswordDialogVisible = true;
    },
    async onModifyPasswordSubmit() {
      if (this.form.newPassword != this.form.rePassword) {
        this.$alert("两次输入的密码不一样", "密码错误", {
          confirmButtonText: "确定"
        });

        return;
      }
      await this.$store.dispatch("me", {
        packageName: "sys",
        className: "sysUser",
        methodName: "updatePassword",
        params: {
          id: this.user.id,
          password: this.form.newPassword,
          rePassword: this.form.rePassword
        }
      });

      this.refresh();

      this.$message.success("修改密码成功！");

      this.modifyPasswordDialogVisible = false;
    }
  }
};
</script>
<style lang="less">
.el-tabs__header {
  width: 40%;
  margin: 0 auto;
}
.el-tabs__nav-wrap::after {
  z-index: -1;
}
</style>

<style lang="less" scoped>
.number {
  font-size: 16px;
  // color: #1b994f;

  font-weight: normal;
}

.form {
  width: 300px;
  margin: 0 auto;
}
.avatar {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  margin: 0 auto 20px auto;
}

.el-main {
  width: 1366px;
  margin: 0 auto;
  background: #f7faf8;

  .header {
    width: 1100px;
    margin: 60px auto;
    text-align: center;
    .background {
      position: absolute;
      width: 1100px;
      height: 205px;

      background: #000;
      opacity: 0.75;

      img {
        width: 100%;
        height: 100%;
        filter: blur(50px);
      }

      border-radius: 5px;
      overflow: hidden;
    }

    .top {
      vertical-align: top;
      width: 120px;
      margin: 0 490px;
      position: relative;
      top: -50px;
      height: 90px;
      img {
        width: 120px;
        height: 120px;
        border-radius: 50%;
      }

      opacity: 0.99;
    }

    .name {
      color: white;

      opacity: 0.99;

      font-size: 18px;
    }

    .active-value {
      margin: 15px auto;
      width: 100px;
      height: 20px;
      background: rgba(229, 244, 234, 1);
      border-radius: 12px;
      color: rgba(27, 153, 79, 1);
      line-height: 20px;
      opacity: 0.99;
      font-size: 12px;
      text-align: center;
    }

    .modify {
      margin-top: 20px;
      opacity: 0.99;
      //   background: rgb(51, 51, 51, 0.3);
      color: white;
      font-size: 13px;
      height: 13px;
      line-height: 13px;

      cursor: pointer;

      img {
        width: 13px;
        height: 13px;
      }
    }
  }

  .body {
    width: 1100px;
    margin: 100px auto;

    .tabs {
      // width: 300px;
      margin: 0 auto;
    }
  }
}
</style>

